import React,{useState, useEffect} from "react";
import { Link } from "react-router-dom";

function Header() {
  const [menuOn, setMenuOn] = useState(false);
  // useEffect(() => {
  //   document.location.href = "https://blog.naver.com/daegupepe";
  // }, [])
  
  
  return (
    <header>
      <a href="/"><img src="/image/hd_logo.png" alt="" /></a>

      {/* <nav className="pc">
        <div className="wrap">
          <Menu></Menu>
        </div>
      </nav> */}

      {/* <div className="mobile button" onClick={()=>{setMenuOn(!menuOn)}}>
      <i class="fa-solid fa-bars"></i>
      </div>

      <nav className={menuOn === true ? "mobile on" : "mobile"}>
        <div className="wrap">
          <Menu></Menu>
        </div>
      </nav>

      <div className={menuOn === true ? "bg on" : "bg"} onClick={()=>{setMenuOn(false)}}></div> */}

      {/* <div className="side">
        <Link to={"/"} onClick={() => { alert("준비중입니다.") }}><img src="/image/side01.png" alt="" /></Link>
        <a href="tel:053-252-0808"><img src="/image/side02.png" alt=""/></a>
        <Link to={"/"} onClick={()=>{alert("준비중입니다.")}}><img src="/image/side03.png" alt=""/></Link>
        <Link to={"/"} onClick={()=>{alert("준비중입니다.")}}><img src="/image/side04.png" alt=""/></Link>
        <button onClick={()=>{window.scrollTo(0,0)}}><i class="fa-solid fa-caret-up"></i>TOP</button>
      </div> */}
    <Popup></Popup>
    </header>
  )
}

function Menu() {
  return (
    <ul>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>병원소개</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>요로결석</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>전립선</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>혈뇨</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>성병</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>남성클리닉</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>여성클리닉</Link></li>
      <li><Link to={"/"} onClick={()=>{alert("준비중입니다.")}}>소아클리닉</Link></li>
    </ul>
  )
}

function Popup() {
  const [popup, setPopup] = useState(true);
  return (
    <div style={popup === false ? {display:"none"} : {}}>
      <div className="bg"></div>
      <div className="pop">
        <img src="/image/popup.jpg" alt="" />
        <div onClick={()=>{setPopup(false)}}>닫기</div>
      </div>
    </div>
  )
}

export default Header;